const state = {
  records: [],
  activeRecordIndex: null,
  galleryVisibility: false,
};

export const getters = {
  getRecords: $state => $state.records,
  getActiveRecordIndex: $state => $state.activeRecordIndex,
  getGalleryVisibility: $state => $state.galleryVisibility,
};

export const actions = {};

export const mutations = {
  setRecords($state, data) {
    $state.records = data;
  },
  setActiveRecordIndex($state, index) {
    $state.activeRecordIndex = index;
  },
  setGalleryVisibility($state, visible) {
    $state.galleryVisibility = visible;
  },
  resetGalleryView($state) {
    $state.records = [];
    $state.activeRecordIndex = null;
    $state.galleryVisibility = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
